import { sendEventToJumbo } from './jumbo';

export const ORDER_EVENTS = {
  GET_ORDER_BASIC_INFO_SUCCESS: 'get_order_basic_info_success',
  GET_ORDER_BASIC_INFO_FAILURE: 'get_order_basic_info_failure',
  GET_REFUND_WARNINGS_SUCCESS: 'get_refund_warnings_success',
  GET_REFUND_WARNINGS_FAILURE: 'get_refund_warnings_failure',
  ADD_MANUAL_TAG_SUCCESS: 'add_manual_tag_success',
  ADD_MANUAL_TAG_FAILURE: 'add_manual_tag_failure',
  COMMENTS_MODAL_OPEN: 'comments_modal_open',
  COMMENTS_MODAL_CLOSE: 'comments_modal_close',
  ESCALATION_MODAL_OPEN: 'escalation_modal_open',
  ESCALATION_MODAL_CLOSE: 'escalation_modal_close',
  MANUAL_TAG_SEARCH_BOX_OPEN: 'manual_tag_search_box_open',
  MANUAL_TAG_SEARCH_BOX_CLOSE: 'manual_tag_search_box_close',
  TRANSACTION_MODAL_OPEN: 'transaction_modal_open',
  DELIGHT_FEATURE_MODAL_OPEN: 'delight_feature_modal_open',
  DOMINOS_MODAL_OPEN: 'dominos_modal_open',
  ORDER_MODAL_CLOSE: 'order_modal_close',
  RELOAD_ORDER_EVENT: 'reload_order_event',
  REPORT_AN_ISSUE_BOX_OPEN: 'report_an_issue_box_open',
  REPORT_AN_ISSUE_BOX_CLOSE: 'report_an_issue_box_close',
  GET_REPLACE_ORDER_BASIC_INFO: 'get_replace_order_basic_info_event',
  ORDER_BILL_MODAL_OPEN: 'order_bill_modal_open',
  ORDER_BILL_MODAL_CLOSE: 'order_bill_modal_close',
  COOKING_INSTRUCTION_MODAL_OPEN: 'cooking_instruction_modal_open',
  COOKING_INSTRUCTION_MODAL_CLOSE: 'cooking_instruction_modal_close',
  GET_COOKING_INSTRUCTION_SUCCESS: 'get_cooking_instruction_success',
  GET_COOKING_INSTRUCTION_FAILURE: 'get_cooking_instruction_failure',
  SELECT_CLUBBER_ORDER_TAB_EVENT: 'select_clubbed_order_tab_event',
};

export const sendOrderApiEvents = (
  eventName,
  orderId,
  customerId,
  requestMeta = {},
) => {
  sendEventToJumbo({
    eventName,
    orderId,
    customerId,
    requestMeta,
  });
};

export const sendOrderModalEvents = (
  eventName,
  orderId,
  customerId,
  requestMeta = {},
) => {
  sendEventToJumbo({
    eventName,
    orderId,
    customerId,
    requestMeta,
  });
};

export const sendManualTagEvents = (eventName, orderId, customerId) => {
  sendEventToJumbo({
    eventName,
    orderId,
    customerId,
  });
};

export const sendReloadOrderEvent = (orderId, customerId) => {
  sendEventToJumbo({
    eventName: ORDER_EVENTS.RELOAD_ORDER_EVENT,
    orderId,
    customerId,
  });
};

export const sendClubbedOrderEvents = (
  eventName,
  orderId,
  customerId,
  requestMeta = {},
) => {
  sendEventToJumbo({
    eventName,
    orderId,
    customerId,
    requestMeta,
  });
};
